import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const studies = [
  {
    id: "ss-enterprises", client: "SS Enterprises", title: "An AI-powered ERP connected to WhatsApp",
    brief: "Bring workforce and operational workflows into one system, with WhatsApp feeding information into the CRM.",
    built: "A custom AI-powered ERP covering labour, inventory, attendance, and work progress tracking, plus an AI chatbot. The WhatsApp integration automatically feeds information into the CRM.",
    result: "The completed system reduces manual data entry and saves the team time by moving information from WhatsApp into the CRM automatically.",
    tags: ["Custom software", "AI integration", "ERP & CRM"],
  },
  {
    id: "grow-partner", client: "Grow Partner Agency", title: "Lead follow-up and review response automation",
    brief: "Support lead handling across channels and review responses across the agency’s client locations.",
    built: "An AI-powered omnichannel lead automation and follow-up engine, alongside Google Business Profile review reply automation for 42 client locations.",
    result: "Both automation projects were delivered. The client’s published feedback highlights on-time delivery, support, and additional features beyond the original scope.",
    tags: ["Workflow automation", "Lead operations", "Marketing"],
  },
  {
    id: "ai-search", client: "Sujay Chokkasamudram", title: "An AI search dashboard, delivered and deployed",
    brief: "Develop an AI search dashboard to the client’s agreed requirements.",
    built: "An AI search dashboard, with support during deployment and communication throughout development.",
    result: "The client’s published feedback confirms prompt delivery, fulfillment of the agreed requirements, and assistance with deployment.",
    tags: ["Custom software", "AI search", "Deployment"],
  },
];

export default function CaseStudiesSection() {
  return (
    <section id="case-studies" className="border-t border-white/10 py-24" aria-labelledby="case-studies-title">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <h2 id="case-studies-title" className="section-title mb-6">From business workflow<br /><span className="text-gradient">to working software.</span></h2>
        <p className="section-subtitle max-w-2xl mb-14">Selected completed projects: what the work involved, what we delivered, and the outcomes shared with us.</p>
        <div className="space-y-12">
          {studies.map(study => (
            <article id={study.id} key={study.id} className="border-t border-white/10 pt-10 grid md:grid-cols-[1fr_1.2fr] gap-8 md:gap-12">
              <div>
                <h3 className="font-unbounded text-xl md:text-2xl text-white leading-snug">{study.client}: {study.title}</h3>
                <ul className="flex flex-wrap gap-2 mt-6" aria-label="Capabilities used">{study.tags.map(tag => <li key={tag} className="text-sm text-neon-cyan border border-white/10 rounded-full px-3 py-1">{tag}</li>)}</ul>
              </div>
              <dl className="space-y-5 text-muted-foreground leading-relaxed">
                <div><dt className="text-white font-semibold mb-1">The brief</dt><dd>{study.brief}</dd></div>
                <div><dt className="text-white font-semibold mb-1">What we built</dt><dd>{study.built}</dd></div>
                <div><dt className="text-white font-semibold mb-1">The result</dt><dd>{study.result}</dd></div>
              </dl>
            </article>
          ))}
        </div>
        <Link to="/#booking" className="inline-flex items-center gap-2 text-neon-cyan mt-12 hover:underline">Discuss a similar project <ArrowRight size={18} aria-hidden="true" /></Link>
      </div>
    </section>
  );
}
